import * as React from "react";
const SaveIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={25}
    viewBox="0 0 24 25"
    fill="none"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M7 3.5v3.4c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C7.76 8.5 8.04 8.5 8.6 8.5h6.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C17 7.74 17 7.46 17 6.9V4.5m0 17v-6.4c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437c-.214-.109-.494-.109-1.054-.109H8.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C7 14.26 7 14.54 7 15.1v6.4M21 9.825V16.7c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311c-.642.327-1.482.327-3.162.327H7.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 19.22 3 18.38 3 16.7V8.3c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C5.28 3.5 6.12 3.5 7.8 3.5h6.875c.489 0 .733 0 .963.055.204.05.4.13.579.24.201.123.374.296.72.642l3.126 3.126c.346.346.519.519.642.72.11.18.19.374.24.579.055.23.055.474.055.963Z"
    />
  </svg>
);
export default SaveIcon;
